'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.loadUserID = loadUserID;
exports.createUser = createUser;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var LOAD = 'LOAD';
var LOAD_USER_ID_SUCCESS = 'LOAD_USER_ID_SUCCESS';
var LOAD_FAIL = 'LOAD_FAIL';

var CREATE_USER = 'CREATE_USER';
var CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
var CREATE_USER_FAIL = 'CREATE_USER_FAIL';

var initialState = {
  loaded: false,
  updating: false,
  updateError: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        updating: true
      });
    case LOAD_USER_ID_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        'user_ids': action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false
      });
    case CREATE_USER:
      return (0, _extends3.default)({}, state, {
        updating: true
      });
    case CREATE_USER_SUCCESS:

      return (0, _extends3.default)({}, state, {
        updating: false
      });
    case CREATE_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        updating: false,
        error: action.error
      });

    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.admin && globalState.admin.loaded;
}

// load
function loadUserID() {
  return {
    types: [LOAD, LOAD_USER_ID_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/admin/getUserID');
    }
  };
}

function createUser(state) {
  var username = state.username;
  var password = state.password;
  return {
    types: [CREATE_USER, CREATE_USER_SUCCESS, CREATE_USER_FAIL],
    promise: function promise(client) {
      return client.post('/admin/createUser', {
        params: {
          username: username,
          password: password
        }
      }).then(function (result) {
        var userId = result.userId;
        return client.post('/profile/update', {
          data: {
            userId: userId,
            state: state
          }
        });
      });
    }
  };
}
/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/admin.js
// module id = 323
// module chunks = 0